import { Icon } from '@/modules/Icon';
import { IconType } from '@/shared/types/types';
import { cn } from '@/shared/utils/cn';
import React from 'react';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

export interface ListEmptyProps {
  title?: string;
  description?: string;
  icon?: IconType;
  className?: string;
}

export const ListEmpty: React.FC<ListEmptyProps> = ({
  title = 'Aun no hay nada aquí',
  description = 'No hay elementos aun en esta lista.\nVuelve más tarde para ver las actualizaciones.',
  icon = faSearch,
  className,
}) => {
  return (
    <div
      className={cn(
        'ui-flex ui-flex-col ui-items-center ui-justify-center ui-gap-8 ui-p-64 ui-text-center',
        className,
      )}
    >
      {/* Icon Container */}
      <div className="ui-flex ui-h-64 ui-w-64 ui-items-center ui-justify-center ui-rounded-control-pill ui-bg-surface-brand">
        <Icon name={icon} className="ui-text-32 ui-text-brand" />
      </div>

      {/* Content */}
      <div className="ui-max-w-[305px]">
        <div className="ui-mb-8 ui-text-body-md-regular ui-font-body-md-semibold ui-text-primary">
          {title}
        </div>
        <div className="ui-whitespace-pre-line ui-text-body-xs-regular ui-leading-relaxed ui-text-secondary">
          {description}
        </div>
      </div>
    </div>
  );
};
